import type { VersionDetailItem } from '@/utils/types/flavorVersion';
import { exportIdentifier } from './identifier';

function escapeTsvCell(s: string): string {
  // TSV has no standard quoting; collapse tabs/newlines to single spaces so columns line up.
  return s.replace(/[\t\r\n]+/g, ' ');
}

export function buildFlaskTsv(items: VersionDetailItem[]): string {
  const header = ['Substance Name', 'Identifier', 'Amount', 'Unit'];
  const rows = items.map((r) => [
    r.substanceName,
    exportIdentifier(r),
    r.amountValue == null ? '' : String(r.amountValue),
    r.amountUnit ?? '',
  ]);
  return [header, ...rows]
    .map((row) => row.map(escapeTsvCell).join('\t'))
    .join('\n');
}
